import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

interface BarcodeProps {
  value: string;
  height?: number;
  width?: number;
  fontSize?: number;
  displayValue?: boolean;
  format?: string;
  className?: string;
}

export const Barcode = ({
  value,
  height = 28,
  width = 1,
  fontSize = 8,
  displayValue = true,
  format = "CODE128",
  className,
}: BarcodeProps) => {
  const ref = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (!ref.current || !value) return;
    try {
      JsBarcode(ref.current, value, {
        format,
        width,
        height,
        fontSize,
        displayValue,
        margin: 0,
        background: "transparent",
        lineColor: "#000",
      });
    } catch (e) {
      // ignore invalid value
    }
  }, [value, height, width, fontSize, displayValue, format]);

  return <svg ref={ref} className={className} />;
};

export default Barcode;
